export var themeData = [
    { label: "Beo classic", value: "saga-orange" },
    { label: "Beo classic dark", value: "arya-orange" },
    { label: "Beo Blue", value: "lara-light-blue" },
    { label: "Beo Blue Dark", value: "arya-blue" },
    { label: "Beo Green", value: "lara-light-green" },
    { label: "Beo Green Dark", value: "arya-green" },
    { label: "Amber", value: "lara-light-amber" },
    { label: "Amber dark", value: "lara-dark-amber" }
];
export var languagedata = [
    { label: "English", value: "en" },
    { label: "German", value: "de" },
];
